import React from 'react';
import styled from 'styled-components';
import Slider from '../Components/Slider';
import {words} from '../translations'
import Likert from '../Components/Likert';

const Question = ({ question, saveUpdatedAnswers, currentQuestionDet, language,qualifier,team_qualifier,teamName,organizationInfo,useLikert,fr_qualifier, customHeader }) => {

  const get_qualifier = () =>{
    if(team_qualifier){
      return words['team_qualifier'][language].replace('{team}',teamName)
    }

    if(question?.qualifier){
      return question?.qualifier
    }

    if(qualifier){
      if(language== 'FR' && fr_qualifier){
        return fr_qualifier
      }

      if(language== 'FR' && qualifier == 'In the hockey environment (training and competition)...'){

        return 'Dans l’environnement du hockey (entraînement et compétition)...'
      } 

      if(language == 'FR' && qualifier == "In our hockey environment..."){
        return "Dans notre environnement de hockey..."
      }
      return qualifier
    }



    return words["qualifier"][language]
   
  }

  const getQuestion = () =>{
    if(language== 'FR' && question?.fr){
      return renderMarkdownLite(question?.fr)
    }
    if(language == 'ES' && question?.es){
      return renderMarkdownLite(question?.es)
    }
    if(language == 'POR' && question?.por){
      return renderMarkdownLite(question?.por)
    }
    return renderMarkdownLite(question?.question)
  }

  const getSurveyHeader = () =>{
    if(organizationInfo?.custom_survey_header){
      if(language == 'FR' && organizationInfo?.custom_survey_header_fr){
        return organizationInfo?.custom_survey_header_fr
      }
      if(language == 'ES' && organizationInfo?.custom_survey_header_es){
        return organizationInfo?.custom_survey_header_es
      }
      if(language == 'POR' && organizationInfo?.custom_survey_header_por){
        return organizationInfo?.custom_survey_header_por
      }
      return organizationInfo?.custom_survey_header
    } 
    if(question?.title) return question.title
    return words["Culture Question"][language]
  }

  const renderInlineBold = (text) => {
    const parts = String(text).split(/(\*\*[^*]+?\*\*)/g)
    return parts.map((part, idx) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={idx}>{part.slice(2, -2)}</strong>
      }
      return part
    })
  }

  const renderSmallText = (text) => {
    const parts = String(text).split(/(<small>[^<]+<\/small>)/g)
    return parts.map((part, idx) => {
      if (part.startsWith('<small>') && part.endsWith('</small>')) {
        const content = part.slice(7, -8) // Remove <small> and </small>
        return <SmallText key={idx}>{renderInlineBold(content)}</SmallText>
      }
      return renderInlineBold(part)
    })
  }

  const renderMarkdownLite = (content) => {
    if (!content) return null
    if (React.isValidElement(content)) return content

    const normalized = String(content)
      .replace(/\r\n|\r/g, '\n')
      .replace(/\\n/g, '\n')

    const paragraphs = normalized.split(/\n{2,}/)
    return paragraphs.map((para, pIdx) => {
      const lines = para.split(/\n/)
      return (
        <p key={pIdx}>
          {lines.map((line, lIdx) => (
            <React.Fragment key={lIdx}>
              {renderSmallText(line)}
              {lIdx < lines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </p>
      )
    })
  }

  const getScaleType = () =>{

    if(useLikert){
      return <Likert
      key={currentQuestionDet?.id}
      id={`slider-track-${currentQuestionDet?.id}`} 
      question={question} 
      language={language}
      useLikert={useLikert}
      saveUpdatedAnswers={saveUpdatedAnswers} 
      currentQuestionDet={currentQuestionDet} />
    }

    return <Slider
    key={currentQuestionDet?.id}
    id={`slider-track-${currentQuestionDet?.id}`} 
    question={question} 
    language={language}
    saveUpdatedAnswers={saveUpdatedAnswers} 
    currentQuestionDet={currentQuestionDet} />  
  }


 return (<QuestionContainer>
  {!organizationInfo?.survey_header ? (
    customHeader?.useImageAsQualifier && customHeader?.imageUrl ? (
      <HeaderImage
        src={customHeader.imageUrl}
        alt=""
        $height={customHeader.imageHeight}
      />
    ) : (
      <Title style={{color: organizationInfo?.custom_survey_header_color || undefined}}>{getSurveyHeader()}</Title>
    )
  ) : null}
    {!organizationInfo?.remove_survey_qualifier && <Qualifier bold={!question?.qualifier}>{get_qualifier()}</Qualifier>}
    <QuestionText bold={question?.qualifier}>{getQuestion()}</QuestionText>
   {getScaleType()}
  </QuestionContainer>)
};
export default Question;

const QuestionContainer = styled.div`
  width: 100%;
  max-width:600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const HeaderImage = styled.img`
  display: block;
  max-width: 100%;
  height: ${props => (props.$height ? `${props.$height}px` : "auto")};
  margin-bottom: 40px;
`;

const Title = styled.div`
  color: #2D70E2;
  text-transform: uppercase;
  font-size:14px;
  font-weight:600;
  margin-bottom: 40px;
`

const Qualifier = styled.div`
  color:#2A3039;
  font-size:${props=>props.bold?'20px':'16px'};
  font-weight:${props=>props.bold?600:400};
  margin-bottom:14px;
  line-height:1.4;
`

const QuestionText = styled.p`
  font-size: ${props=>props.bold?'20px':'16px'};
  font-weight:${props=>props.bold?600:400};
  color: #2A3039;
`;

const SmallText = styled.small`
  font-size: calc(1rem - 1px);
  line-height: 1.2;
`;

